import Api from "../Api";

export const listQuotes = () => {
  return Api.get("quote").then((res) => res.data);
};

export const getProducts = (search) => {
  return Api.get(`quote/products?search=${search}`).then((res) => res.data);
};

export const createQuote = (data) => {
  return Api.post("quote", data).then((res) => res.data);
};

export const viewQuote = (id) => {
  return Api.get(`quote/${id}`).then((res) => res.data);
};

export const updateQuote = (id, data) => {
  return Api.put(`quote/${id}`, data).then((res) => res.data);
};

export const deleteQuote = (id) => {
  return Api.delete(`quote/${id}`).then((res) => res.data);
};

export const declineQuote = (id) => {
  return Api.patch(`quote/${id}`).then((res) => res.data);
};

export const getQuoteCheckout = (id) => {
  return Api.get(`quote/${id}/checkout`).then((res) => res.data);
};

export const acceptQuote = (id, data) => {
  return Api.post(`quote/${id}`, data).then((res) => res.data);
};

export const requestRFQAccess = () => {
  return Api.post("customer/rfq-access").then((res) => res.data);
};

export const getRFQAccess = () => {
  return Api.get("customer/rfq-access").then((res) => res.data);
};
